"use client";

import {
  IconPaperBag,
  IconStar,
  IconToolsKitchen3,
  IconTruck,
} from "@tabler/icons-react";
import { useLocale, useTranslations } from "next-intl";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
} from "@/components/ui/carousel";

export const HeroStatsBar = () => {
  const t = useTranslations("staticBuilder");
  const locale = useLocale();
  const stats = [
    {
      id: "caterings",
      icon: IconPaperBag,
      label: t("stats.caterings", {
        count: locale === "cz" ? "5+" : "40+",
      }),
    },
    {
      id: "orders",
      icon: IconToolsKitchen3,
      label: t("stats.orders", {
        count: locale === "cz" ? "12 000+" : "100 000+",
      }),
    },
    {
      id: "delivery",
      icon: IconTruck,
      label: t("stats.delivery"),
    },
    {
      id: "rating",
      icon: IconStar,
      label: t("stats.rating"),
    },
  ] as const;
  return (
    <section className="bg-brand-grey4">
      <div className="container py-4">
        <Carousel opts={{ align: "start", dragFree: true }}>
          <CarouselContent className="ml-0 gap-10 xl:justify-center">
            {stats.map((stat) => {
              const Icon = stat.icon;

              return (
                <CarouselItem className="basis-auto pl-0" key={stat.id}>
                  <div className="flex items-center gap-3 whitespace-nowrap">
                    <div className="flex size-12 shrink-0 items-center justify-center rounded-full bg-brand-green2-300 text-brand-white">
                      <Icon className="size-6" stroke={1.75} />
                    </div>
                    <p className="font-medium text-brand-green2-300 text-lg leading-6.5">
                      {stat.label}
                    </p>
                  </div>
                </CarouselItem>
              );
            })}
          </CarouselContent>
        </Carousel>
      </div>
    </section>
  );
};
